import { Injectable, inject } from '@angular/core';
import { SiaSignalrMessage } from '../interfaces/sia-signalr-message';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SignalrApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'signalr';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  SendCustomMessage(message: SiaSignalrMessage) {
    return this.http.post(`${this.apiController}/message`, message);
  }
}
